import * as defaultImport from "@splunk/react-icons/TrashCanCross";
export * from "@splunk/react-icons/TrashCanCross";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
